import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "order-until" };
const _hoisted_2 = { class: "order-until__icon" };
const _hoisted_3 = { class: "order-until__content" };
const _hoisted_4 = { class: "order-until__datetime" };
const _hoisted_5 = { class: "order-until__date" };
const _hoisted_6 = { class: "order-until__time" };
const _hoisted_7 = { key: 1 };
import { onMounted, onUnmounted, ref } from 'vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import deliveries from "../services/DeliveryRepository";
import moment from "moment";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
const reloadEvery = 60 * 1000; // 1 min
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeOrderUntil',
    setup(__props) {
        const orderUntilDate = ref(null);
        const orderUntilTime = ref(null);
        const nextDeliveryDate = ref(null);
        const nextDeliveryWeekday = ref(null);
        const interval = ref(null);
        const loading = ref(true);
        onMounted(() => {
            findNextDeliveryDate();
            interval.value = window.setInterval(findNextDeliveryDate, reloadEvery);
        });
        onUnmounted(() => {
            interval.value && window.clearInterval(interval.value);
        });
        function findNextDeliveryDate() {
            loading.value = true;
            deliveries
                .listShippingOptions()
                .then((shippingOptions) => {
                const next = shippingOptions.deliveryDayOptions
                    .find(o => o.deliverable !== 'NO_DELIVERY' && o.orderDateTime && moment(o.orderDateTime).isAfter());
                if (next) {
                    const nextMoment = moment(next.targetDate);
                    nextDeliveryDate.value = nextMoment.toDate();
                    nextDeliveryWeekday.value = nextMoment.format('ddd');
                    const orderUntilMoment = moment(next.orderDateTime);
                    orderUntilTime.value = orderUntilMoment.format('HH:mm');
                    orderUntilDate.value =
                        orderUntilMoment.isSame(moment(), 'day')
                            ? trans('delivery.today')
                            : orderUntilMoment.format('DD.MM.YYYY');
                }
            })
                .finally(() => {
                loading.value = false;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Icon, {
                        name: "alarm-clock",
                        "icon-style": "duotone"
                    })
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (!loading.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (nextDeliveryDate.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('delivery.latest_time_for', { day: nextDeliveryWeekday.value, date: _ctx.$date(nextDeliveryDate.value) })), 1),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(orderUntilDate.value), 1),
                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(orderUntilTime.value), 1)
                                    ])
                                ], 64))
                                : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('delivery.latest_time_unavailable')), 1))
                        ], 64))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
